import { useCallback } from "react";

import { toast } from "@/components/flexkit/toast";
import { useStopAgentExecution } from "@/queries/agent-queries";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { formatError } from "@/utils/errors";

export const useAgentExecutionActions = (agentExecution?: PlainAgentExecution) => {
    const stopAgentExecution = useStopAgentExecution();

    const copyAgentExecutionId = useCallback(async () => {
        if (!agentExecution?.id) {
            toast({ title: "No session ID available to copy" });
            return;
        }
        await navigator.clipboard.writeText(agentExecution.id);
        toast({ title: "Session ID copied to clipboard" });
    }, [agentExecution?.id]);

    const handleStopAgentExecution = useCallback(async () => {
        if (!agentExecution?.id) {
            toast({ title: "No session ID available to stop" });
            return;
        }
        try {
            await stopAgentExecution.mutateAsync({ agentExecutionId: agentExecution.id });
        } catch (error) {
            toast({
                title: "Failed to stop session",
                description: formatError(error),
            });
        }
    }, [agentExecution?.id, stopAgentExecution]);

    return {
        copyAgentExecutionId,
        handleStopAgentExecution,
        isStopPending: stopAgentExecution.isPending,
    };
};
